import { Hand, LogoTelegram } from "@gravity-ui/icons";
import { Button, Flex, Icon, Text } from "@gravity-ui/uikit";
import { POIZON_API_SUPPORT_LINK } from "src/constants/links";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { T, useTranslate } from "src/i18n";

import { TextSection } from "../TextSection";
import css from "./ContactsBlock.module.scss";

export const ContactsBlock = () => {
  const { isMobile, deviceText } = useGravityDevice();
  const { t } = useTranslate();

  return (
    <Flex
      id="links"
      direction={"column"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        gap: 60,
      }}
    >
      <TextSection
        title={t("landing.contacts_block.title", "Контакты")}
        description={t(
          "landing.contacts_block.description",
          "Если у Вас возникли какие-либо вопросы, вы можете задать их нашей поддержке 24/7",
        )}
      />

      <Flex justifyContent={"space-between"} wrap={"wrap"} gap={6}>
        <div className={css.telegramLinkBlock}>
          <Flex direction={"column"} gap={6}>
            <Text variant={deviceText.subheader}>
              <T
                keyName={"landing.contacts_block.block_1.title"}
                defaultValue={"Поддержка 24/7"}
              />
            </Text>
            <Text variant={deviceText.body} as="h3">
              <T
                keyName={"landing.contacts_block.block_1.description"}
                defaultValue={
                  "Тебе нужна помощь по внедрению API? Или у тебя возник вопрос по оплате? Напиши нам!"
                }
              />
            </Text>
          </Flex>

          <Button
            size={isMobile ? "l" : "xl"}
            view="action"
            href={POIZON_API_SUPPORT_LINK}
            target="_blank"
          >
            <Icon data={Hand} />
            <T
              keyName={"landing.contacts_block.block_1.button"}
              defaultValue={"Спросить"}
            />
          </Button>
        </div>
        <div className={css.telegramLinkBlock}>
          <Flex gap={6} direction={"column"}>
            <Text variant={deviceText.subheader}>
              <T
                keyName={"landing.contacts_block.block_2.title"}
                defaultValue={"Будь в курсе происходящего. Следи за новостями"}
              />
            </Text>
            <Text variant={deviceText.body} as="h3">
              <T
                keyName={"landing.contacts_block.block_2.description"}
                defaultValue={
                  "Мы активно развиваем сервис. Постоянно выходят обновления, мы стараемся предоставить больше новых возможностей для парсинга и доставки товаров."
                }
              />
            </Text>
          </Flex>

          <Button
            size={isMobile ? "l" : "xl"}
            view="flat-info"
            selected
            href="https://t.me/PoizonAPI"
            target="_blank"
          >
            <Icon data={LogoTelegram} />
            <T
              keyName={"landing.contacts_block.block_2.button"}
              defaultValue={"Подписаться"}
            />
          </Button>
        </div>
      </Flex>
    </Flex>
  );
};
